import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import {KeyTextField, LinkField} from '@prismicio/types';
    import {linkResolver} from '../app/link-resolver';
    import {usePrismicFieldHelpers} from '../composables/usePrismicFieldHelpers';
    import {useTypeGuards} from '../composables/useTypeGuards';

    type Props = {
        field: LinkField | KeyTextField;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ServerSideNavigationPrismicLink',
  props: {
    field: null
  },
  setup(__props: any) {

const props = __props as {
        field: LinkField | KeyTextField;
    };

    

    const {isLink} = usePrismicFieldHelpers();

    const {isFilledWebLink, isFilledKeyText, isFilledContentRelationshipField} = useTypeGuards();

    function shouldShow(): boolean {
        return isFilledKeyText(props.field) || isLink('_', props.field);
    }

    function href(): string {
        const field = props.field;
        if (isFilledKeyText(field)) {
            return field;
        }
        if (field && isFilledWebLink(field)) {
            return field.url;
        }
        if (field && isFilledContentRelationshipField(field)) {
            return linkResolver(field);
        }
        return '';
    }

return (_ctx: any,_cache: any) => {
  return (shouldShow())
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: href()
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})